import * as React from 'react'

import type User from 'modules/core/store/models/User'

import EmployeeLabel from 'modules/surveys/components/Form/CommonEmployeeLabel'
import AnonymousUser from 'modules/surveys/components/Participants/common/AnonymousUser'

import MeAnonymousLabel from 'modules/surveys/components/Participants/common/MeAnonymousLabel'

interface Props {
  user: User | null | undefined
  isAnonymous?: boolean
}

export default function EmployeeLabelWithFallback({ user, isAnonymous }: Props) {
  if (user && isAnonymous) return <MeAnonymousLabel user={user} /> // currentUserAnonymous
  if (user) return <EmployeeLabel user={user} />
  return <AnonymousUser />
}
